'use client';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import {
	A11y,
	Navigation,
	Pagination,
	Scrollbar,
} from 'swiper/modules';

import { Swiper } from 'swiper/react';
import type { SwiperProps } from 'swiper/react';

type DynamicSwiperProps = {
	children: React.ReactNode;
} & SwiperProps;

const DynamicSwiper = ({ children, ...rest }: DynamicSwiperProps) => {
	return (
		<Swiper
			loop
			navigation
			autoplay={{ delay: 5000 }}
			modules={[ Navigation, Pagination, Scrollbar, A11y ]}
			pagination={{
				dynamicBullets: true,
				clickable:      true,
			}}
			slidesPerView={1}
			{...rest}
		>
			{children}
		</Swiper>
	);
};

export default DynamicSwiper;